var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{class:[
        'client-avatar',
        _vm.inverted ? _vm.color + '-invert' : _vm.color,
        _vm.clickable ? 'clickable' : ''
    ],attrs:{"size":_vm.large ? 80 : _vm.size,"tile":""}},[_c('span',{class:[
            _vm.inverted ? _vm.color + '--text' : 'white--text',
            _vm.large ? 'display-1 font-weight-regular' : (_vm.text_class + " font-weight-bold")
        ]},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }